import React from "react";
import {Typography, Stack} from "@mui/material";

import '../../css/App.css';
import {copyToClipboard} from "../../helpers/TextUtils";
import CopyIconButton from "../common/CopyIconButton";

export default function HyperlinkText({ url, key, label, handleLinkClick, onCopy = copyToClipboard }) {
    return (
        <Stack direction="row" alignItems="center">
            <CopyIconButton url={url} onCopy={onCopy} ariaLabel="copy recording link" fontSize="1.25rem" />
            <a style={{textDecoration: "underline", color: "white"}}
               href={url} target={"_blank"}
               onClick={() => handleLinkClick(url)}
               rel="noreferrer">
                <Typography key={key} variant="subtitle2" color="white">{label}</Typography>
            </a>
        </Stack>
    );
}
